const KEY = 'cfpl_from_blog';
const TTL_MS = 30 * 60 * 1000; // 30 min — enough to read the article, navigate, and vote

interface FromBlogEntry { slug: string; setAt: number; }

export function setFromBlogFlag(slug: string): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ slug, setAt: Date.now() } satisfies FromBlogEntry));
  } catch { /* ignore */ }
}

export function readFromBlogFlag(): { slug: string } | false {
  if (typeof window === 'undefined') return false;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return false;
    const entry = JSON.parse(raw) as FromBlogEntry;
    if (Date.now() - entry.setAt > TTL_MS) {
      sessionStorage.removeItem(KEY);
      return false;
    }
    return { slug: entry.slug };
  } catch { return false; }
}

export function clearFromBlogFlag(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
